import React from 'react';
import Helmet from 'react-helmet';

import config from '../utils/siteConfig';

import Layout from '../components/Layout';
import Container from '../components/Container';
import Header from '../components/Header';
import Hero from '../components/home_elements/Hero';
import Featured from '../components/home_elements/Featured';
import Platters from '../components/home_elements/Platters';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const initialState = {
    navOpen: false,
    selectedLang: 'en'
};

const Index = props => {
    const socialData = {
        shareTitle: `${config.siteTitle} | Home`,
        shareFacebook: `Facebook share description for Publix Hispanic Family Celebrations.`,
        shareTwitter: `Twitter share description for Publix Hispanic Family Celebrations.`,
        shareImage: `${config.shareImage}`
    };

    const pagePath = props.location.pathname;

    return (
        <Layout root={pagePath} globalState={initialState}>
            <Helmet>
                <title>{`${config.siteTitle}`} | Home</title>
                <meta name="description" content={config.siteDescription} />
                <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
            </Helmet>
            <SEO socialData={socialData} pagePath={pagePath} />

            <Container>
                <div id="home">
                    <Header pagePath={pagePath} langKey="en" />
                    <Hero langKey="en" />
                    <Featured pagePath={pagePath} langKey="en" />
                    <Platters langKey="en" />
                    <Footer pagePath={pagePath} langKey="en" />
                </div>
            </Container>
        </Layout>
    );
};

export default Index;
